'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var Table = function Table(props) {
    return _react2['default'].createElement('table', _extends({}, props, {
        className: (0, _classnames2['default'])('Table', props.className),
        cellPadding: '0',
        cellSpacing: '0'
    }));
};

Table.propTypes = {
    className: _propTypes2['default'].string
};

module.exports = Table;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Table.js
// module id = 983
// module chunks = 0 1